export function getFlexContentProps(props) {
    var classes = {
        '__grid': true,
    };
    return {
        classes: classes,
        props: {},
        styles: {},
        variables: {}
    };
}
export function getContainerFlexProps(props) {
    var styles = {};
    if (typeof props.gap !== 'undefined')
        styles.gap = props.gap;
    if (typeof props.rowGap !== 'undefined')
        styles.rowGap = props.rowGap;
    if (typeof props.columnGap !== 'undefined')
        styles.columnGap = props.columnGap;
    var elementMode = props.elementMode;
    var classes = {
        '__columns': props.columns,
        '__rows': props.rows || !props.columns,
        '__no-wrap': props.noWrap,
        '__content': elementMode === 'container',
        '__row': elementMode === 'row' || !elementMode,
    };
    return {
        classes: classes,
        styles: styles,
        props: {},
        variables: {}
    };
}
export function getColFlexProps(props) {
    var _a;
    if (props.auto)
        props.cols = 'auto';
    if (typeof props.mobile !== 'undefined' ||
        typeof props.xs !== 'undefined' ||
        typeof props.sm !== 'undefined' ||
        typeof props.md !== 'undefined' ||
        typeof props.lg !== 'undefined' ||
        typeof props.xl !== 'undefined') {
        if (typeof props.xs !== 'undefined') {
            if (typeof props.mobile === 'undefined')
                props.mobile = props.xs;
        }
        else if (typeof props.sm !== 'undefined') {
            if (typeof props.xs === 'undefined')
                props.xs = props.sm;
            if (typeof props.mobile === 'undefined')
                props.mobile = props.sm;
        }
        if (typeof props.cols !== 'undefined') {
            if (typeof props.mobile === 'undefined')
                props.mobile = props.cols;
            if (typeof props.xs === 'undefined')
                props.xs = props.cols;
            if (typeof props.sm === 'undefined')
                props.sm = props.cols;
            if (typeof props.md === 'undefined')
                props.md = props.cols;
            if (typeof props.lg === 'undefined')
                props.lg = props.cols;
            if (typeof props.xl === 'undefined')
                props.xl = props.cols;
            props.cols = undefined;
        }
    }
    if (typeof props.xs !== 'undefined') {
        if (typeof props.mobile === 'undefined')
            props.mobile = props.xs;
    }
    else if (typeof props.sm !== 'undefined') {
        if (typeof props.xs === 'undefined')
            props.xs = props.sm;
        if (typeof props.mobile === 'undefined')
            props.mobile = props.sm;
    }
    var classes = (_a = {
            '__col': true,
            '__col-fixed': props.fixed
        },
        _a["__col-".concat(props.cols)] = typeof props.cols === 'number',
        _a['__col-auto'] = props.cols === 'auto',
        _a['mobile__col'] = props.mobile === true,
        _a['xs__col'] = props.xs === true,
        _a['sm__col'] = props.sm === true,
        _a['md__col'] = props.md === true,
        _a['lg__col'] = props.lg === true,
        _a['xl__col'] = props.xl === true,
        _a['mobile__col-auto'] = props.mobile === 'auto',
        _a['xs__col-auto'] = props.xs === 'auto',
        _a['sm__col-auto'] = props.sm === 'auto',
        _a['md__col-auto'] = props.md === 'auto',
        _a['lg__col-auto'] = props.lg === 'auto',
        _a['xl__col-auto'] = props.xl === 'auto',
        _a["mobile__col-".concat(props.mobile)] = typeof props.mobile === 'number',
        _a["xs__col-".concat(props.xs)] = typeof props.xs === 'number',
        _a["sm__col-".concat(props.sm)] = typeof props.sm === 'number',
        _a["md__col-".concat(props.md)] = typeof props.md === 'number',
        _a["lg__col-".concat(props.lg)] = typeof props.lg === 'number',
        _a["xl__col-".concat(props.xl)] = typeof props.xl === 'number',
        _a['mobile__col-hidden'] = props.mobile === 'hidden',
        _a['xs__col-hidden'] = props.xs === 'hidden',
        _a['sm__col-hidden'] = props.sm === 'hidden',
        _a['md__col-hidden'] = props.md === 'hidden',
        _a['lg__col-hidden'] = props.lg === 'hidden',
        _a['xl__col-hidden'] = props.xl === 'hidden',
        _a);
    return {
        classes: classes,
        props: {},
        styles: {},
        variables: {}
    };
}
export function getSpacerFlexProps(props) {
    var classes = {
        '__spacer': true,
        '__spacer__auto': props.auto,
        '__spacer__vertical': props.vertical,
    };
    return {
        classes: classes,
        props: {},
        styles: {},
        variables: {}
    };
}
